import React from 'react';
import SectionContent from '../section-content/SectionContent';
import { LastVisitedLessonContentFragment, SllLesson, SllModule, SllSectionFragment } from '@api/graphql-codegen'
import { useStandaloneContent } from '@src/hooks/useStandaloneContent';

type Props = {
  contents: SllModule[];
  lesson?: SllLesson | SllSectionFragment;
  lastVisitedLesson?: LastVisitedLessonContentFragment;
  closeNav?: () => void;
  isPreparation?: boolean;
  selectedModuleIndex?: number;
};

function SectionContents(props: Props) {
  const { contents, lesson, closeNav, isPreparation, selectedModuleIndex=0 } = props;
  const { content: selectedContent, lesson: selectedLesson, section: selectedSection, isPreProgramQuiz, isNewLessonLayout } = useStandaloneContent();
  
  return (
    <>
      {(contents || []).map((content, index) => {
        const sectionSelected = selectedContent?.id === content.id && (isPreProgramQuiz || isPreparation || (selectedSection ? selectedSection?.id === lesson?.id : selectedLesson?.id === lesson?.id));
        return <SectionContent lastVisitedLesson={undefined} key={content.id} selected={sectionSelected || (isNewLessonLayout && index < selectedModuleIndex)} content={content as SllModule} lesson={lesson} closeNav={closeNav} />
      })}
      
    </>
  );
}

export default SectionContents;
